module.exports = __webpack_public_path__ + "static/scale-model-of-r-v-caravan-tours-in-eugene-oregon-c2c43f54a33f9582f22ec6d48a2bb624.png";